import React, { useEffect, useState } from "react";
import { UserData, searchSubOrg } from "../../../../api";

export default function SubOrganization({ subOrgs, openAddSubOrgModal }) {
    const [SubOrganizations, setSubOrgs] = useState(subOrgs);
    const [user, setUser] = useState(null);
    useEffect(() => {
        setSubOrgs(subOrgs);
    }, [subOrgs]);

    useEffect(() => {
        UserData().then((response) => {
            setUser(response);
        });
    }, []);

    const handleChange = (evt) => {
        searchSubOrg({ search_term: evt.target.value })
            .then((res) => {
                if (res.status) {
                    setSubOrgs(res.data.data);
                }
            })
            .catch((err) => {});
    };

    return (
        <>
            <div className="panel-heading" id="pannel-headingId">
                <div className="header-search">
                    <form>
                        <input
                            type="text"
                            placeholder="Search Sub Organization"
                            name="search"
                            onChange={handleChange}
                        />
                        <button>
                            <i className="fa fa-search"></i>
                        </button>
                    </form>
                </div>
                <div className="d-flex">
                    {user?.role == "admin" && user?.sub_org_id == null ? (
                        <button
                            className="orgbtn"
                            onClick={() => openAddSubOrgModal(true)}
                        >
                            <i className="fa fa-create"></i> Add Sub
                            Organization
                        </button>
                    ) : (
                        ""
                    )}
                </div>
            </div>

            <div className="table-organizations">
                <table
                    className="table table-striped table-responsive"
                    id="organization-index-table"
                >
                    <tr>
                        <th>Sub Organization Name</th>
                        <th>Members</th>
                    </tr>
                    <tbody>
                        {SubOrganizations && SubOrganizations.length > 0 ? (
                            SubOrganizations.map((subOrg, index) => (
                                <tr key={index}>
                                    <td>{subOrg.sub_org_name}</td>
                                    <td>{subOrg.user_count}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={2}>
                                    <span>No data found</span>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
}
